import React from 'react';
import './auth.css';
import { useDispatch, useSelector } from "react-redux";
import { authAction, recoveryPasswordAction, registrationAction } from "../../redux/actions";
import { signInSagaAction } from "../../redux/sagaActions";
import {
    RECOVERY_PASSWORD_FORM_INITIAL
} from "../../redux/initialStateConstants";
import { GetRegistrationDocsThunk } from "../../redux/thunks/GetRegistrationDocsThunk";

const Auth = () => {
    const dispatch = useDispatch();

    const auth_form = useSelector(state => state.auth_form);

    return (
        <div className="auth">
            <div className="form__field">
                <div className="input__caption input__caption--required">Почта</div>
                <input type="text" className="input"
                       value={ auth_form.email }
                       onInput={ event => dispatch(authAction({
                           ...auth_form,
                           email: event.target.value
                       })) }/>
            </div>
            <div className="form__field">
                <div className="input__caption input__caption--required">Пароль</div>
                <input type="password" className="input"
                       value={ auth_form.password }
                       onInput={ event => dispatch(authAction({
                           ...auth_form,
                           password: event.target.value
                       })) }
                />
            </div>
            <div className="form__field">
                <div
                    className="button"
                    onClick={ () => dispatch(signInSagaAction({
                        email: auth_form.email,
                        password: auth_form.password
                    })) }
                >Войти</div>
            </div>
            <div className="form__field"/>
            <div className="form__field">
                <div className="form__link" onClick={ () => {
                    // Запрашиваем список файлов для согласия
                    dispatch(GetRegistrationDocsThunk());
                } }>Зарегистрироваться</div>
            </div>
            <div className="form__field">
                <div className="form__link" onClick={ () => {
                    // Закрываем форму авторизации
                    dispatch(authAction({
                        ...auth_form,
                        open: false
                    }));
                    // Открываем форму восстановления пароля
                    dispatch(recoveryPasswordAction({
                        ...RECOVERY_PASSWORD_FORM_INITIAL,
                        open: true
                    }));
                } }>Восстановить пароль</div>
            </div>
        </div>
    );
};

export default Auth;